module.exports = __webpack_public_path__ + "img/shape-7.285f5ff1.svg";